<template>
<div class="container">

    <rc-widget-live-results-body
      page_basename="house" 
      page_name="House"
    ></rc-widget-live-results-body>

</div>
</template>

<script>

import ElectionNightMixin from './ElectionNightMixin.js';

const RcWidgetLiveResultsBody = () => import(/* webpackChunkName: "RcWidgetLiveResultsBody" */ "./RcWidgetLiveResultsBody.vue");

export default {
    name: 'rc-widget-live-results-house',
    mixins: [
        ElectionNightMixin,
    ],
    components: {
        'rc-widget-live-results-body': RcWidgetLiveResultsBody,
    },
}
</script>

<style lang="scss">

</style>